module.exports = __webpack_public_path__ + "img/groupischeck.34dcff7b.png";